import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectMeterDefaults, updateDefaults } from '../../../../redux/panelDetailSlice';

export default function MeterSizeSection() {
  const dispatch = useDispatch();
  const meter = useSelector(selectMeterDefaults);

  const handleChange = (phaseKey, field, value) => {
    const numVal = parseFloat(value);
    if (isNaN(numVal)) return;
    dispatch(updateDefaults({
      section: 'meter',
      changes: { [phaseKey]: { [field]: numVal } },
    }));
  };

  return (
    <div className="detail-section-content">
      <div className="detail-two-col">
        <div className="detail-col">
          <div className="detail-col-title">3 Faz Sayac</div>
          <div className="detail-field">
            <label>Genislik (cm)</label>
            <input
              type="number"
              step="0.5"
              value={meter.phase3.width}
              onChange={e => handleChange('phase3', 'width', e.target.value)}
            />
          </div>
          <div className="detail-field">
            <label>Yukseklik (cm)</label>
            <input
              type="number"
              step="1"
              value={meter.phase3.height}
              onChange={e => handleChange('phase3', 'height', e.target.value)}
            />
          </div>
        </div>
        <div className="detail-col">
          <div className="detail-col-title">1 Faz Sayac</div>
          <div className="detail-field">
            <label>Genislik (cm)</label>
            <input
              type="number"
              step="0.5"
              value={meter.phase1.width}
              onChange={e => handleChange('phase1', 'width', e.target.value)}
            />
          </div>
          <div className="detail-field">
            <label>Yukseklik (cm)</label>
            <input
              type="number"
              step="1"
              value={meter.phase1.height}
              onChange={e => handleChange('phase1', 'height', e.target.value)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
